export function hasScoring(schema: Record<string, unknown> | undefined | null): boolean {
  if (!schema) return false;
  if (Array.isArray(schema['calculatedValues']) && (schema['calculatedValues'] as unknown[]).length > 0) return true;
  if (Array.isArray(schema['completedHtmlOnCondition']) && (schema['completedHtmlOnCondition'] as unknown[]).length > 0) return true;
  return false;
}
